module.exports = __webpack_public_path__ + "media/images/h_logo-0a0554b2.png";